import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AppHeader } from "@/components/AppHeader";
import { ArrowLeft } from "@phosphor-icons/react";

export default function Tradelines() {
  const { user } = useAuth();
  return (
    <div className="min-h-screen bg-background flex flex-col">
      {user ? (
        <AppHeader />
      ) : (
        <header className="sticky top-0 z-50 border-b border-white/10 bg-zinc-950/60 backdrop-blur-xl">
          <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
            <Link to="/" className="flex items-center gap-2">
              <span className="font-display text-xl tracking-tighter">DAFARGOS</span>
              <span className="overline text-primary mt-1">Holdings LLC</span>
            </Link>
            <Link to="/" className="text-sm text-muted-foreground hover:text-foreground inline-flex items-center gap-2">
              <ArrowLeft size={16} /> Home
            </Link>
          </div>
        </header>
      )}

      <main className="flex-1 flex flex-col max-w-6xl w-full mx-auto px-6 py-10">
        <div className="mb-6">
          <div className="overline text-primary mb-2">Tradelines</div>
          <h1 className="font-display text-3xl md:text-4xl tracking-tighter">Book an Authorized-User Tradeline</h1>
          <p className="text-sm text-muted-foreground mt-2">
            Browse and book available tradelines directly below.
          </p>
        </div>
        <div className="flex-1 min-h-[70vh] rounded-xl border border-white/10 overflow-hidden bg-white">
          <iframe
            data-testid="tradeline-iframe"
            title="Tradeline Booking Page"
            src="https://app.tradelinescore.com/authorized-user-tradeline/bFVObndNTHV5K0tRdHIvQWhyZnh1QT09"
            width="100%"
            height="100%"
            style={{ minHeight: "70vh", border: "none", display: "block" }}
          />
        </div>
      </main>
    </div>
  );
}
